<template>
  <Datepicker
    v-model="date"
    :valueType="valueType"
    :format="format"
    :clearable="false"
    :disabled="disabled"
    :placeholder="placeholder"
    :lang="{
      days: ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
      yearFormat: 'YYYY',
      monthFormat: 'MMMM',
    }"
    @input="$emit('input', date)"
  >
    <template v-slot:icon-calendar>
      <img v-if="isHasCalendarIcon" src="../../../public/custom/images/calendar.svg" alt="Calendar image">
      <svg v-else></svg>
    </template>
  </Datepicker>
</template>

<script>
import Datepicker from "vue2-datepicker";
import "vue2-datepicker/locale/ru";
import 'vue2-datepicker/index.css';

export default {
  name: "BaseDatepicker",
  components: {
    Datepicker,
  },
  props: {
    defaultValue: String,
    isHasCalendarIcon: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    valueType: {
      type: String,
      default() {
        return 'YYYY-MM-DD';
      }
    },
    format: {
      type: String,
      default() {
        return 'YYYY-MM-DD';
      }
    }
  },
  data() {
    return {
      date: "" || this.defaultValue,
    };
  },
  watch: {
    defaultValue(value) {
      this.date = value;
    }
  }
};
</script>

<style lang="scss" scoped></style>
